import { render, staticRenderFns } from "./WordOptionsPopup.vue?vue&type=template&id=96fad84a&"
import script from "./WordOptionsPopup.vue?vue&type=script&lang=ts&"
export * from "./WordOptionsPopup.vue?vue&type=script&lang=ts&"
import style0 from "./WordOptionsPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports